"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = exports.DrawerFooter = exports.DrawerBody = exports.DrawerTitle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const React = __importStar(require("react"));
const clsx_1 = require("clsx");
const __1 = require("..");
const prefix = 'tk-drawer';
const buildClass = (classStr) => `${prefix}__${classStr}`;
const componentFactory = (_a, name) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.clsx)(buildClass(name), className) }, rest, { children: children })));
};
const DrawerTitle = (props) => componentFactory(props, 'title');
exports.DrawerTitle = DrawerTitle;
const DrawerBody = (props) => componentFactory(props, 'body');
exports.DrawerBody = DrawerBody;
const DrawerFooter = (props) => componentFactory(props, 'footer');
exports.DrawerFooter = DrawerFooter;
const Drawer = (_a) => {
    var { width = 350, position = 'right', relativeToWindow = false, className, children, closeButton = true, show = true, onClose = () => null, hasBackdrop = false } = _a, rest = __rest(_a, ["width", "position", "relativeToWindow", "className", "children", "closeButton", "show", "onClose", "hasBackdrop"]);
    const minWidth = 200;
    const positionClasses = (0, clsx_1.clsx)({
        [`${prefix}--${position}`]: position,
        [`${prefix}-hidden`]: !show,
    });
    const relativeToClasses = (0, clsx_1.clsx)({
        [`${prefix}--relative-to-window`]: relativeToWindow,
    });
    const handleContentClick = (event) => event.stopPropagation();
    const handleClose = React.useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        onClose();
    }, [onClose]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [hasBackdrop && show && ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.clsx)(`${prefix}-backdrop`, relativeToClasses), onClick: handleClose })), (0, jsx_runtime_1.jsxs)("div", Object.assign({}, rest, { role: "dialog", className: (0, clsx_1.clsx)(prefix, positionClasses, relativeToClasses, className), style: { width: width > minWidth ? width + 'px' : minWidth + 'px' }, onClick: handleContentClick, children: [closeButton && ((0, jsx_runtime_1.jsx)(__1.SvgIcon, { "aria-label": "close", className: (0, clsx_1.clsx)(buildClass('close')), icon: __1.Icons.Cross, onClick: onClose })), children] }))] }));
};
exports.Drawer = Drawer;
